
<div class="ft-party">

    <mat-form-field #formFieldContainer floatLabel="always" appearance="none">
      <mat-label
        #labelContainer  (click)="toggleTooltip(tooltip)"
        class="{{componentDefinition?.mandatory ? 'mandatory' : ''}} ">
        {{componentDefinition?.label}}
      </mat-label>
      <div class="labelToolTipContainer"
        #tooltip="matTooltip"
        matTooltip="{{componentDefinition.label}}"
        [matTooltipDisabled]="showToolTip(tooltip,formFieldContainer,labelContainer)">
      </div>
      <input matInput [hidden]="true" [id]="elementName" [name]="componentDefinition?.name"/>
    </mat-form-field>

  <div class="party-fields-container">
    <mat-form-field floatLabel="never" class="ft-salutation ft-party-field">
      <mat-select
        disableOptionCentering
        panelClass="ft-dropdown-center"
        class="ft-party-dropdown"
        placeholder="Salutation"
        [id]="salutationIdName"
        (selectionChange)="valueChangedParty('salutation',$event.value)"
        [formControl]="formControlSalutation"
        [errorStateMatcher]="matcherSalutation"
        [(value)]="selectedTitleValue"
        [title]="salutationInputTitle?salutationInputTitle:'Salutation'">

        <mat-select-trigger
          [ngClass]="{
          'isEmptyTitle':selectedTitleValue === 'Salutation',
          'isNotEmptyTitle':selectedTitleValue !== 'Salutation'}">
          {{selectedTitleValue}}
        </mat-select-trigger>

        <mat-option value=""></mat-option>
        <mat-option *ngFor="let selectedOption of titleDropDownList; trackBy: trackByFn" [value]="selectedOption">
          {{selectedOption}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field floatLabel="never" class="ft-fname ft-party-field">
      <input matInput
             placeholder="FirstName"
             [id]="firstNameIdName"
             [name]="firstNameIdName"
             [formControl]="formControlFirstName"
             [errorStateMatcher]="matcherFirstName"
             [title]="firstNameInputTitle?firstNameInputTitle:'FirstName'"/>
    </mat-form-field>

    <mat-form-field floatLabel="never" class="ft-lname ft-party-field">
      <input matInput
             placeholder="Surname"
             [id]="surnameBusinessIdName"
             [name]="surnameBusinessIdName"
             [formControl]="formControlSurname"
             [errorStateMatcher]="matcherSurname"
             [title]="surnameInputTitle?surnameInputTitle:'Surname'"/>
    </mat-form-field>

  </div>
  <ft-validation-display [model]="document" [componentDefinition]="componentDefinition"></ft-validation-display>

</div>
